import classes from '../index.module.scss'

export const BackgroundPath = ({
  size,
  backgroundPathFill,
  backgroundPathStroke,
  backgroundPathStrokeWidth,
}) => {
  return (
    <svg
      style={{
        width: size,
        height: size,
        top: size / 2,
      }}
      className={classes.backgroundPathSvg}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2}
        fill={backgroundPathStroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - backgroundPathStrokeWidth}
        fill={backgroundPathFill}
      />
    </svg>
  )
}
